module.exports = __webpack_public_path__ + "static/media/csite-home-illustration.588cba8d.png";